import getOptions from "./get-options";

/**
 *
 * @param {OptionsListMapProps} common
 * @param {String} local
 * @param {MainClassProps} main
 * @returns
 */
const inheritOptions = (common, local, main) => {
  const supported = new Set(["duration", "easing"]);

  if (!common && !local) {
    return null;
  }

  const options = getOptions(local, main, 0) || new Map();

  /** Parent (timeline) an local options */
  if (common && local) {
    for (const [name, value] of common) {
      if (supported.has(name) && !options.has(name)) {
        options.set(name, value);
      }
    }
  } else if (common) {
    for (const [name, value] of common) {
      if (supported.has(name) && !options.has(name)) {
        options.set(name, value);
      }
    }
  }

  return options;
};

export default inheritOptions;
